export const WEEKDAYS = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
